import { Module } from 'vuex';
import LanguageCode from '@/locale/language-code';
import KeywordsCMSModel from '@/visa-application/models/KeywordsCMSModel';
import { getLocalStorage, setLocalStorage } from '@/shared/utils/utils';
import ApplicationCenterCMSModel from '@/visa-application/models/ApplicationCenterCMSModel';
import DirectusService from '@/core/directus/directus.service';

export const translationStore: Module<any, any> = {
  state: {
    currentLanguage: getLocalStorage('currentLanguage') ? getLocalStorage('currentLanguage') : LanguageCode.EN,
    languageFrom: getLocalStorage('currentLanguage') ? 'localStorage' : 'code',
    keywords: KeywordsCMSModel,
    applicationCenter: [ApplicationCenterCMSModel]
  },
  getters: {
    currentLanguage: state => state.currentLanguage,
    languageFrom: state => state.languageFrom,
    keywords: state => state.keywords,
    applicationCenter: state => state.applicationCenter
  },
  mutations: {
    currentLanguage(state, newLanguage) {
      state.currentLanguage = newLanguage;
      state.languageFrom = 'storeCommit';
      setLocalStorage('currentLanguage', newLanguage);
    },
    keywords(state, keywords) {
      state.keywords = keywords;
      setLocalStorage('keywords', keywords);
    },
    applicationCenter(state, applicationCenter) {
      state.applicationCenter = applicationCenter;
    },
    languageFrom(state, languageFrom) {
      state.languageFrom = languageFrom;
    }
  }
};
